<app-multi-select-dropdown
    context="division-filter assets"
    dropdownLabel="Division"
    [options]="divisions$ | async"
    (submitDropdownMultiSelect)="submitDropdownMultiSelect($event)"
>
</app-multi-select-dropdown>